export interface NavLink {
  readonly label: string;
  readonly href: string;
  readonly primary?: boolean;
}
export interface NavSection {
  readonly label: string;
  readonly links: readonly NavLink[];
}
export interface NavGroup {
  readonly label: string;
  readonly kind: 'link' | 'flat' | 'panel';
  readonly href?: string; // kind: 'link'
  readonly links?: readonly NavLink[]; // kind: 'flat'
  readonly sections?: readonly NavSection[]; // kind: 'panel'
}

export const NAV_GROUPS: readonly NavGroup[] = [
  // Home IS the online-lessons hub (spec §5, P3): the brand lockup is the
  // home link, so this is the only entry for `/` and it says what the page is.
  { label: 'Online Lessons', kind: 'link', href: '/' },
  { label: 'Testimonials', kind: 'link', href: '/bass-lessons/testimonials' },
  { label: 'Blog', kind: 'link', href: '/blog' },
  {
    label: 'About',
    kind: 'panel',
    sections: [
      {
        label: 'Russ',
        links: [
          { label: 'Bio', href: '/about/bio' },
          { label: 'Credits', href: '/about/credits' },
          { label: 'Resume', href: '/about/resume' },
        ],
      },
      {
        label: 'Music',
        links: [
          { label: 'Performance', href: '/about/performance' },
          { label: 'X-Ploration Jazz', href: '/x-ploration-jazz' },
          { label: 'Discography', href: '/about/discography' },
          { label: 'Gear', href: '/about/gear' },
        ],
      },
    ],
  },
];
